import removeBlankProperties from 'utils/removeBlankProperties';
import get from 'lodash/get';
import map from 'lodash/map';

function makeSentinelTeamIdentity(sentinelTeam = {}) {
  /* istanbul ignore next -- @preserve */
  const {
    id,
    name,
    owner = {},
    teamType,
    teamKey,
    platformAccounts = [],
    oemSegment = {},
  } = sentinelTeam || {};

  return removeBlankProperties({
    id,
    name,
    owner: get(owner, 'email'),
    teamType,
    teamKey,
    platformAccounts: map(platformAccounts, (account) => account.sourceId),
    oemSegmentId: get(oemSegment, 'id'),
    oemSegmentName: get(oemSegment, 'name'),
    oemSegmentKey: get(oemSegment, 'key'),
  });
}

export default makeSentinelTeamIdentity;
